import { dcPortTerminalGroups } from "./component-ports";
import type { DefLookup } from "./catalog";
import type { System } from "./types";
import { v, type Vertex } from "./diagnostics/graph";

export type DcOutputPort = { nodeId: string; positive: Vertex[]; negative: Vertex[] };

/** A converter output is a separate DC supply, even with no battery on that
 * rail. These are design ports, not assertions that the input is live. Keeping
 * each pair separate prevents a missing return borrowing another output's. */
export function dcOutputPorts(system: System, lookup: DefLookup): DcOutputPort[] {
  return system.nodes.flatMap(node => {
    if (node.kind !== "component") return [];
    const def = lookup(node.definitionId, node.customDefinition);
    if (!def || !["charger", "load", "source"].includes(def.category)) return [];
    return dcPortTerminalGroups(def, "output").flatMap(port => {
      const positive = port.filter(t => t.polarity === "positive").map(t => v(node.id, t.id));
      const negative = port.filter(t => t.polarity !== "positive").map(t => v(node.id, t.id));
      return positive.length && negative.length ? [{ nodeId: node.id, positive, negative }] : [];
    });
  });
}
